module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("My utmost thanks to the following for providing their barns, stories and assistance for this project:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("(in order of appearance)")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("The Timber Framers Guild")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Jane Fox, Freeport")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Freeport Historical Society")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Tom and Diana Allen, Sebago")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Bridgton Historical Society")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("David and Terry Gagnon, Denmark")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Mike Deering, Saco")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Lois Deering Starbird, Solon")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Dan and Sarah Pierce, New Gloucester")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("George, Gene and Mary Lou Stacey, Hiram")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Sally Williams, Hiram")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Rick Gerrish, Milo")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Milo Historical Society")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Richard and Geraldine Anderson, Scarborough")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Carmel Morin, New Gloucester")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Ryan Tripp, New Gloucester")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Garin and Sarah Smith, Skowhegan")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Stephanie Calder, Skowhegan")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Bob Bartlett (deceased), formerly of Oxford")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Elizabeth Dominic, Searsport")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Hank and Heidi Thorburn, Harpswell")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Gail Hart, Harpswell")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Peter, George and James Haines, Bethel")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Randall, Jill and Allison Bates, New Vineyard")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Dan and Claudia Sortwell, Wiscasset")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Clarence and Juliet Plourde, Caribou")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Dan Deveau, Cyr Plantation")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Ken Arndt, Presque Isle")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Shawn Michaud, Easton")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Noah Yoder, Fort Fairfield")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Granville “Peaunt” Perkins, Fort Fairfield")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("John and Marie Dudley, Alexander")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Richard Carlow, Wesley")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Aaron Bell and Carly DelSignore, Edmunds Township")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Roger Knight, Scarborough")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Jim Leary, Saco")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("George Hall, Windham")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Jeremie Berube, Arundel")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Scott Hatch, Harrison")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Scott Burner, Windham")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Mike Franck, Gorham")]), _vm._v(" "), _c('p', {
    staticClass: "noindent3"
  }, [_vm._v("A very special thanks also goes out to those who backed this project on "), _c('i', [_vm._v("Kickstarter")]), _vm._v(" and became “barn backers.”")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Joey Brunelle, San Francisco, California")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Angelo Castigliola, Biddeford, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Gene Cetrone, Rinebeck, New York")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Bill and Ruth Crane, Windham, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("John and Karen DenBleyker, Millville, New Jersey")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Tama Benson Donovan, Ipswich, Massachusetts")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Bob Fowler, New Gloucester, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Donna Godfrey, Raymond, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("James Haines, Bethel, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Sam Hotchkiss, Portland, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Julie Jenkins, Bangor, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Louise Knapp, Hebron, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Caroline Loupe, New Gloucester, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Dave Martel, Saco, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Paul and Nancy Michaud, Caribou, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Fabien and Brenda Pelletier, Wallagrass, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Deborah Perkins, Poland, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Janine Pineo, Hudson, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Bill Punsky, Cape Elizabeth, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Andrew and Nina Roth-Wells, Georgetown, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Caroline Sample, Cumberland, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Susan Simonson, Westbrook, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Wendy Smith, Windham, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Daniel and Claudia Sortwell, Wiscasset, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Jeff Stanton, South Portland, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Iain and Ada Dawn Stenhouse, Poland, Maine")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Jonathan Stern, San Diego, California")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("Chandler Vreeland, Marietta, Georgia")]), _vm._v(" "), _c('p', {
    staticClass: "ref"
  }, [_vm._v("John Warden, Alexandria, Virginia")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c560b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ack.vue
// module id = 72
// module chunks = 0